var render = function render(){var _vm=this,_c=_vm._self._c;return _c('c-select',{attrs:{"title":"ПЕРИОД:","form-group":"","form-group-margin-bottom":"","options":_vm.monthsFormated,"bold":_vm.isRangeTypeMonth,"label-width":_vm.labelWidth,"select-width":_vm.selectWidth},model:{value:(_vm.month),callback:function ($$v) {_vm.month=$$v},expression:"month"}})
}
var staticRenderFns = []

export { render, staticRenderFns }